<template>
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center my-4">
        <h2 class="mb-0 hk-heading"> Latest Articles & Blogs</h2>
       <a class="know-more" href="/news-blogs">Explore HotelKey Blogs</a>
      </div>
    </div>
    <div class="row">
      
      <div 
      v-for="enterprise in EnterpriseNews.slice(0, 3)" :key="enterprise"
      @click="enterprise.link_url ? GotoLinkuse(enterprise.link_url) : GoEnterpriseDetails(enterprise.id)"
        class="col-md-4 my-4"
      >
        <div class="card h-100">
          <img :src="require(`@/assets/news-blog/enterprise/${enterprise.img_url}`)" class="card-img-top" :alt='enterprise.title' loading="eager">
          <div class="card-body pt-4 pb-4">
            <b class=" color-date">{{ enterprise.posted_date }}</b>
            <h5 class=" mt-3 card-title">{{ enterprise.title }}</h5>

            <!-- <p class="card-text">{{ card.text }}</p> -->
            <!-- <a :href="card.link" class="know-more">{{ card.linktext }}</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsBlogDetails from '@/assets/json/news-blogs.json'
import { marked } from 'marked'
export default {
  
  data() {
    return {
      AllNewsBlogDetails: NewsBlogDetails,
      EnterpriseNews: [],
      cards: [
        {
          title: "Sojern Elevates Guest Experience with HotelKey",
          text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
          image: require("@/assets/aboutus/blog-sojern-elevates-guest.webp"),
          link: "#",
          linktext: "Read News & Articles",        
          },
        {
          title: "Lodging “On Demand with Aditya Thyagarajan”",
          text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
                   image: require("@/assets/aboutus/blog-aditya-thyagarajan.webp"),
          link: "#",
          linktext: "HotelKey Products",        
          },
        {
          title: "Adopting Mindful Spending: 14 Ways to Reduce Your Hotel Expenses",
          text: "Some quick example text to build on the card title and make up the bulk of the card's content.",
                   image: require("@/assets/aboutus/blog-hotel- expenses.webp"),
          link: "#",
          linktext: "Explore Blogs",        
          },
      ],
    };
  },
  mounted() {
this.EnterpriseNews = this.AllNewsBlogDetails.enterprise.slice(0, 4);
},
  methods:{
    markdownToHtml(message) {
            return marked(message);
        },
    GoEnterpriseDetails(_id) {
            let route = this.$router.resolve({ path: 'enterprise-news', query: { _id: _id } })
            window.open(route.href);
        },
        GotoLinkuse(link) {
            window.open(link, '_blank')
        },

  }
};
</script>

 <style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";
.card {
  padding: 0;
  cursor: pointer;
}
.know-more {
  color: #1d6fba;
  font-size: 13px;
  font-weight: 600;
  text-decoration-line: underline;
}.headline{
  color: #040404;
font-family: Poppins;
font-size: 24px;

font-weight: 600;
}
.card-title{
  color: #000;
font-family: Poppins;
font-size: 20px;
font-weight: 500;
}
.color-date{
  color: #5c5c5c;
    font-size: 14px;
    font-weight: 500;
}
</style>
